import { render, staticRenderFns } from "./_StockUpChart.vue?vue&type=template&id=363145f0&scoped=true"
import script from "./_StockUpChart.vue?vue&type=script&lang=js"
export * from "./_StockUpChart.vue?vue&type=script&lang=js"
import style0 from "./_StockUpChart.vue?vue&type=style&index=0&id=363145f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363145f0",
  null
  
)

export default component.exports